import { render, staticRenderFns } from "./CmTextMedia.vue?vue&type=template&id=7a9f69f8"
import script from "./CmTextMedia.vue?vue&type=script&lang=ts"
export * from "./CmTextMedia.vue?vue&type=script&lang=ts"
import style0 from "./CmTextMedia.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Headline: require('/app/components/base/Headline/Headline.vue').default,LinkComponent: require('/app/components/base/LinkComponent/LinkComponent.vue').default,VideoComponent: require('/app/components/base/VideoComponent/VideoComponent.vue').default,ImageComponent: require('/app/components/base/ImageComponent/ImageComponent.vue').default})
